module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAqCAYAAADMKGkhAAAAAXNSR0IArs4c6QAAAT9JREFUWEftmTFKBTEQhr9R0UIUbBQEvYwg2tlZPvACYisewNbSOwiexMrGxkJFDyAI2uzIv7xiyymSR/KYVLsQ/nz5MrAZ1gDcfQvYB9b13vj4AT5sDv0IHDUOPMW7Ffgh8NYRtFAHge8CL8BOR/BPAjfgGDgD1lTyDW9ArKrxOz2Mw91XGwaeog1mNtruciT4oo8tjafxoIEslaCoYtPSeDGVwaA0HhRVbNpyGHf3lWJKKgWZ2aBo3ccFewlcAa2Dq0L+gHOBq0n+rCSoVuyXwA+A91orVMr9FfgGcA/MKi1SI3Y2bd025z1njYVKZn5n61ZSZzRrOT5A0d22MC+NL/oU0ngaDxrIUgmKKjYtjRdTGQwajbv7KXADbDf+R0K4anoudB/fA14BXWt7Gc+9/nUbm2WZfgBOetENXP8DdeROTEU/fiUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = +HEJ
// module chunks = 0